import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import { Free_Travel_TAG, GROUP_TOUR_TAG } from '../../utils/constants';
import { formatPrice } from '../../utils/formatPrice';
import { jumpToDetail } from '../../utils/jumpUtils';
import { useEffect, createElement } from '@max/max';
import { travelDaysTagImages } from '../../utils/constants';
const isMRN = false;
import ImageBackground from '@hfe/max-imagebackground';
import './horizontalcardstyle.scss';
const HorizontalCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { goodInfo, index, supplyGroupId, pageSourceType, _LXReport } = props;
    const { mvReport, mcReport } = _LXReport;
    const jumpDetail = () => {
        jumpToDetail({
            goodInfo,
            index,
            supplyGroupId,
            pageSourceType,
            mcReport
        });
    };
    const handleView = () => {
        mvReport('b_daodian_lowcode_7s2beos5_mv', {
            valLab: {
                deal_id: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId,
                biz_line: 'holiday',
                dealgroup_id: supplyGroupId,
                item_index: index
            }
        });
    };
    useEffect(() => {
        handleView();
    }, []);
    const actualPrice = (_b = (_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.payPrice) !== null && _b !== void 0 ? _b : goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.sellPrice;
    const categoryTagKey = (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? 3 : 2;
    const categoryTag = (_d = (_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _c === void 0 ? void 0 : _c.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === categoryTagKey)) === null || _d === void 0 ? void 0 : _d.descriptions;
    const productTag = (_f = (_e = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _e === void 0 ? void 0 : _e.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === 1)) === null || _f === void 0 ? void 0 : _f.descriptions;
    const showProductTag = (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.length) > 0 ? productTag === null || productTag === void 0 ? void 0 : productTag.slice(0, 3) : productTag;
    return <View className="horizontal-card-container" onClick={() => {
        jumpDetail();
    }}>
      <View className="horizontal-card-image-view">
        <Image className="horizontal-card-image" source={{
        uri: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsHeadPhoto
    }}/>
      </View>
      <Image className="horizontal-card-image-tag" source={{
        uri: (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? GROUP_TOUR_TAG : Free_Travel_TAG
    }}/>
      {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.departures) && goodInfo.departures.length > 0 && <View className="horizontal-departures-container">
          <LinearGradient className="horizontal-departures-background" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['rgba(51, 51, 51, 0.6)', 'rgba(51, 51, 51, 0.6)']} style={{
        borderBottomRightRadius: 10
    }}/>
          <Text className="horizontal-departures-text">
            {goodInfo.departures.length > 1 ? '多地出发' : `${((_g = goodInfo.departures[0]) === null || _g === void 0 ? void 0 : _g.cityName) || 'X X '}出发`}
          </Text>
        </View>}
      <View className="horizontal-card-content-right">
        <View className="horizontal-card-top-field">
          <View className="horizontal-card-tag-field">
            <Text numberOfLines={2} style={{
        textOverflow: 'ellipsis'
    }}>
              {isMRN && travelDaysTagImages[goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay] ? <ImageBackground style={{
        width: '32rpx',
        height: '32rpx',
        marginTop: '-5rpx'
    }} source={{
        uri: travelDaysTagImages[goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay]
    }}></ImageBackground> : <Text className="horizontal-card-day-h5-tag-text">{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay}</Text>}
              <Text className="horizontal-card-deal-name">{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsName}</Text>
            </Text>
          </View>
          <View className="horizontal-card-tag">
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="horizontal-card-product-tag-group">
                    <Text className="horizontal-card-product-tag-text-group">{item}</Text>
                  </View>;
    }))}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.map((item) => {
        return <View className="horizontal-card-people-tag">
                    <Text className="horizontal-card-people-tag-text">{item}</Text>
                  </View>;
    }))}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="horizontal-card-product-tag-free">
                    <Text className="horizontal-card-product-tag-text-free">{item}</Text>
                  </View>;
    }))}
          </View>
        </View>

        <View className="horizontal-card-bottom-field">
          <View className="horizontal-card-bottom-left-field">
            <View className="horizontal-card-price-field">
              <Text className="horizontal-card-price-now">
                <Text className="horizontal-card-price-icon">¥</Text>
                <Text className="horizontal-card-price-price">{formatPrice(actualPrice)}</Text>
                <Text className="horizontal-card-price-start">起</Text>
              </Text>
            </View>
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice) !== actualPrice && <Text className="horizontal-card-price-origin">{`¥${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice)}`}</Text>}
          </View>
          <LinearGradient className="horizontal-card-bottom-right-field" start={{
        x: 0,
        y: 1
    }} end={{
        x: 1,
        y: 0
    }} colors={['#FF7700', '#FF4B10']}>
            <Text className="horizontal-card-bottom-right-text">{'抢购'}</Text>
          </LinearGradient>
        </View>
      </View>
    </View>;
};
export default HorizontalCard;
